import { render, staticRenderFns } from "./dinoClosed.vue?vue&type=template&id=1e7cfaa0&"
import script from "./dinoClosed.vue?vue&type=script&lang=js&"
export * from "./dinoClosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports